/**
 * Counts down to the cancellation deadline (backend-provided ISO timestamp).
 * Returns ms remaining, or null until the deadline is known.
 */

import { useEffect, useState } from 'react'

export function useCancelCountdown(
  cancelDeadline: string | null | undefined
): number | null {
  const [timeLeftMs, setTimeLeftMs] = useState<number | null>(null)

  useEffect(() => {
    if (!cancelDeadline) {
      setTimeLeftMs(null)
      return
    }

    const deadlineMs = new Date(cancelDeadline).getTime()
    const update = () => {
      const remaining = Math.max(0, deadlineMs - Date.now())
      setTimeLeftMs(remaining)
    }
    update()
    const interval = setInterval(update, 1000)
    return () => clearInterval(interval)
  }, [cancelDeadline])

  return timeLeftMs
}
